import { defineStore } from 'pinia';
import { usePage } from '@inertiajs/vue3';

export const useNotificationsStore = defineStore('notifications', {
  state: () => ({
    unreadNotificationsCount: usePage().props.unreadNotificationsCount as number,
  }),

  actions: {
    /**
     * Decrement notifications count.
     *
     * @param {Number} value
     */
    decrementUnreadNotification(value: number) {
      this.unreadNotificationsCount -= value;
    },
  },
});
